import { Heart } from "lucide-react";

export const FanBadge = ({ className = "" }) => (
  <span data-testid="fan-favourite-badge" className={`inline-flex items-center gap-1 rounded-full bg-[#1B1530] text-white text-[11px] font-bold uppercase tracking-wide px-3 py-1 ${className}`}>
    <Heart className="h-3 w-3 fill-[#FF5A5F] text-[#FF5A5F]" /> Fan favourite
  </span>
);
